import { useTranslation } from 'react-i18next';

export interface IPaginationSrAlertMessageProps {
  currentPage?: number;
  totalPages?: number;
}
/**
 * Componente per visualizzare un messaggio di accessibilità relativo alla pagina corrente della paginazione.
 */
export function PaginationSrAlertMessage(
  props: Readonly<IPaginationSrAlertMessageProps>,
) {
  const { t } = useTranslation();
  return (
    <span className="sr-only" role="alert">
      {t(
        'use-pagination-a11y.current-page-sr-message-total',
        'Pagina corrente {{page}} di {{total}}.',
        {
          page: props.currentPage ?? 1,
          total: props.totalPages ?? 1,
        },
      )}
    </span>
  );
}
